import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DropdownSource, SourceDto } from '../interfaces';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SourcesService {
  private iCourrierURL;
  private sources$: Observable<SourceDto[]>;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  /**
   * Fetches the sources. The full, unfiltered list is cached for the app lifetime (it rarely changes during a session);
   * a call filtered by `ids` always hits the API.
   */
  public fetchSources(ids?: number[]): Observable<SourceDto[]> {
    if (ids?.length) {
      return this.http.get<SourceDto[]>(`${this.iCourrierURL}/Global/Sources?ids=${ids}`);
    } else {
      if (!this.sources$) {
        this.sources$ = this.http.get<SourceDto[]>(`${this.iCourrierURL}/Global/Sources`).pipe(shareReplay(1));
      }
      return this.sources$;
    }
  }

  public fetchMappedSourcesToPrimeNGDropdowns(ids?: number[]): Observable<DropdownSource[]> {
    return this.fetchSources(ids).pipe(
      map((res: SourceDto[]) => {
        const mappedSourcesArray: DropdownSource[] = [];

        res.forEach((source: SourceDto) => {
          let mappedSource: DropdownSource = {} as DropdownSource;
          mappedSource = { ...source, label: source.description, value: source.id };
          mappedSourcesArray.push(mappedSource);
        });

        return mappedSourcesArray;
      })
    );
  }
}
